const dateToDatetimeLocal = (dateString) => {
   let newDate = dateString;
   if (dateString === "" || !dateString) {
      newDate = new Date();
   }
   const dateObject = new Date(newDate);
   //8 chars is ":SS.MMMMZ" of ISO string
   return new Date(
      dateObject.getTime() - dateObject.getTimezoneOffset() * 60000,
   )
      .toISOString()
      .slice(0, -8);
};

const dateToDateLocal = (dateString) => {
   let newDate = dateString;
   if (dateString === "" || !dateString) {
      newDate = new Date();
   }
   return new Date(newDate).toISOString().split("T")[0];
};

const convertToISO8601 = (dateString) => {
   // Parse the input date string into a Date object
   const date = new Date(dateString);
   // Validate the parsed date
   if (isNaN(date.getTime())) {
      throw new Error("Invalid date format");
   }
   // Format the date to ISO 8601 with nanoseconds and Zulu time (UTC)
   const year = date.getUTCFullYear();
   const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are 0-based
   const day = String(date.getUTCDate()).padStart(2, "0");
   const hours = String(date.getUTCHours()).padStart(2, "0");
   const minutes = String(date.getUTCMinutes()).padStart(2, "0");
   const seconds = String(date.getUTCSeconds()).padStart(2, "0");
   const milliseconds = String(date.getUTCMilliseconds()).padStart(3, "0");
   return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}000Z`;
};

const convertToYYYYMMDD = (content) => {
   const isValidFormattedDate = (dateString) => {
      const [year, month, day] = dateString.split("-").map(Number);
      const testDate = new Date(year, month - 1, day);
      return (
         testDate.getFullYear() === year &&
         testDate.getMonth() + 1 === month &&
         testDate.getDate() === day
      );
   };
   const isFormattedDate =
      /^\d{4}-\d{2}-\d{2}$/.test(content) && isValidFormattedDate(content);
   if (isFormattedDate) {
      return content; // Return as-is if already formatted
   }
   const dateObj = new Date(content.toString());
   if (isNaN(dateObj.getTime())) {
      console.error("Invalid date content:", content);
      return ""; // Handle invalid dates
   }
   const year = dateObj.getFullYear();
   const month = String(dateObj.getMonth() + 1).padStart(2, "0");
   const day = String(dateObj.getDate()).padStart(2, "0");
   return `${year}-${month}-${day}`;
};

const convertToDatetimeLocal = (content) => {
   const date = new Date(content); // Parse timestamp into a Date object
   const year = date.getFullYear();
   const month = String(date.getMonth() + 1).padStart(2, "0");
   const day = String(date.getDate()).padStart(2, "0");
   const hours = String(date.getHours()).padStart(2, "0");
   const minutes = String(date.getMinutes()).padStart(2, "0");
   return `${year}-${month}-${day}T${hours}:${minutes}`;
};

export {
   dateToDatetimeLocal,
   dateToDateLocal,
   convertToISO8601,
   convertToYYYYMMDD,
   convertToDatetimeLocal,
};
